document.getElementById('camion').addEventListener('click', function(e) {
    const contenedor = document.querySelector('.seccion-camion-moviendose');
    const plantilla = document.getElementById('plantilla-caja');
    
    // 1. Obtener la posición exacta del camión en la pantalla
    const rectCamion = this.getBoundingClientRect();
    const rectContenedor = contenedor.getBoundingClientRect();

    // 2. Calcular la posición relativa de la caja respecto al contenedor
    // Restamos las posiciones del contenedor por si la página tiene scroll o márgenes
    const posX = rectCamion.left - rectContenedor.left + (rectCamion.width / 3); 
    const posY = rectCamion.top - rectContenedor.top + (rectCamion.height / 2);

    // 3. Clonar el SVG de la plantilla de la caja
    const nuevaCaja = plantilla.cloneNode(true);
    nuevaCaja.removeAttribute('id');
    nuevaCaja.style.display = 'block';
    nuevaCaja.classList.add('caja-cayendo');

    // 4. Asignar las coordenadas mediante propiedades CSS variables
    nuevaCaja.style.left = `${posX}px`;
    nuevaCaja.style.setProperty('--start-y', `${posY}px`);

    // 5. Agregar la caja al contenedor para que empiece a caer
    contenedor.appendChild(nuevaCaja);

    // 6. Limpieza: Eliminar la caja cuando termine la animación (0.8 segundos)
    setTimeout(() => {
        nuevaCaja.remove();
    }, 800);

});